export default "__VITE_ASSET__befcf916__"